module.exports = __webpack_public_path__ + "static/media/matilde-special-crown-impressed.f3681b71.png";